/* eslint-disable no-underscore-dangle */
export default class AuthError extends Error {
    get original() {
        return this.__original;
    }

    set original(value) {
        this.__original = value;
    }

    get description() {
        return this.__description;
    }

    set description(value) {
        this.__description = value;
    }
}
